import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { decodeString } from 'lib/stringUtils';

import styles from './styles.module.scss';

function PullQuote({
  attribution, quip, size, text,
}, {
  amp = false,
}) {
  if (amp) {
    // AMP always small
    size = 'small'; // eslint-disable-line no-param-reassign
  }

  let fontSizeClasses = 'f7';
  if (size === 'small') {
    fontSizeClasses = 'f8';
  } else if (size === 'large') {
    fontSizeClasses = 'f8 f9-l f10-xl';
  }

  return (
    <div className={classNames(styles.pullQuote, { [styles[size]]: !!size })}>
      <div className={styles.grid}>
        <div className={styles.inner}>
          <p className={classNames(styles.content, fontSizeClasses)}>
            {decodeString(text)}
          </p>
          {(attribution || quip) && (
            <p className="founders-mono f3 lh-title mv0 ttu">
              <cite className="fs-normal black" data-test="pullquote-attribution">
                {decodeString(attribution)}
              </cite>
              {(attribution && quip) && (
                // add non-breaking space when there's attribution & quip
                <span>&nbsp;</span>
              )}
              <span className="gray-80" data-test="pullquote-quip">
                {decodeString(quip)}
              </span>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

PullQuote.propTypes = {
  attribution: PropTypes.string,
  quip: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  text: PropTypes.string.isRequired,
};

PullQuote.defaultProps = {
  attribution: null,
  quip: null,
  size: 'small',
};

PullQuote.contextTypes = {
  amp: PropTypes.bool,
};

export default PullQuote;
